module.exports = __webpack_public_path__ + "static/media/exp-arrow.df0f9023.png";